<template>
  <div class="comment-section">
    <div class=" col-md-12 mobile-p-left-0 m-top-10">
      <div class=" col-lg-2 col-md-2 col-xs-2"></div>
      <div class="col-lg-10 col-md-10 col-xs-10 called-name p-left-10 mobile-left-8">{{ log.user_name ? log.user_name : 'System' }} called {{ log.calle_name }}, {{ log.time_formated }}</div>
    </div>

    <div class="col-lg-12 col-md-12 col-xs-12 mobile-p-left-0 m-top-10">
      <div class="comment-photo col-lg-2 col-md-2 col-xs-2">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="#C191FF"/>
          <g clip-path="url(#clip0_4047_43548)">
            <path d="M14.54 13C14.6 13.89 14.75 14.76 14.99 15.59L13.79 16.79C13.38 15.59 13.12 14.32 13.03 13H14.54ZM24.4 25.02C25.25 25.26 26.12 25.41 27 25.47V26.96C25.68 26.87 24.41 26.61 23.2 26.21L24.4 25.02ZM15.5 11H12C11.45 11 11 11.45 11 12C11 21.39 18.61 29 28 29C28.55 29 29 28.55 29 28V24.51C29 23.96 28.55 23.51 28 23.51C26.76 23.51 25.55 23.31 24.43 22.94C24.33 22.9 24.22 22.89 24.12 22.89C23.86 22.89 23.61 22.99 23.41 23.18L21.21 25.38C18.38 23.93 16.06 21.62 14.62 18.79L16.82 16.59C17.1 16.31 17.18 15.92 17.07 15.57C16.7 14.45 16.5 13.25 16.5 12C16.5 11.45 16.05 11 15.5 11Z" fill="#2E4051"/>
          </g>
          <defs>
            <clipPath id="clip0_4047_43548">
              <rect width="24" height="24" fill="white" transform="translate(8 8)"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div class="col-lg-10 col-md-10 col-xs-10 p-all-10 subject-div mobile-left-8">
        <div class="log-details">
          <p class="log-duration">Duration: {{ log.duration }}</p>
        </div>
        <audio class="mobile-width" controls>
          <source :src="log.url" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CallLogRow",
  props: {
    log: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>
.called-name {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color:rgba(46, 64, 81, 1);
}
.user-message{
  padding: 8px 12px 8px 12px;
  border-radius: 20px
}
.subject-div{
  background-color: rgba(0, 140, 250, 0.15);
  border-radius: 20px;
}
audio
{
  width: -webkit-fill-available !important;
  width: -moz-available;

}
@media (max-width: 991px) {
  .mobile-m-top-0 {
    margin-top: 0px;
  }
  .mobile-left-8 {
    left: 8px;
  }
  .mobile-p-left-0 {
    padding-left: 0px;
  }
  .mobile-m-left-44 {
    margin-left: 44px;
  }
  .mobile-width{
    width: -webkit-fill-available !important;
  }
  .mobile-m-left-44 {
    margin-left: 44px;
  }
}

/* only in this case because the logo is bigger than the col*/

@media  (min-width: 500px) and (max-width: 768px)
{
  .col-xs-2
  {

    width: 11%;
    padding: 0 5px 0 10px;
  }
}


@media (min-width: 768px) and (max-width: 992px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 992px) and (max-width: 1100px) {
  .col-lg-2 {

    width: 16%;
    padding: 0px;
  }

}
@media (min-width: 1100px) and (max-width: 1260px) {
  .col-lg-2 {
    width: 15%;
  }
}
@media (min-width: 1260px) and (max-width: 1599px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 1600px) and (max-width: 1920px) {
  .col-lg-2 {
    width: 9%;
  }
}
@media (min-width: 1921px)  and (max-width: 2200px) {
  .col-lg-2 {
    width: 8%;
  }
}
@media (min-width: 2200px)  {
  .col-lg-2 {
    width: 6%;
  }
}
</style>